import { Form } from './form';
import { ProductView } from '../view/product-view';
import { FormTypes } from './form-types';
import { Config } from '../config';
import { QuantityForm } from './quantity-form';
import { Order } from '../config/order';
import { Product } from '../config/product';
import { ProductType } from '../config/product-type';
import { QuantityValidator } from '../validators/quantity-validator';

export class ProductForm extends Form {

    private products: Product[] = [];
    view: ProductView = new ProductView();
    type = FormTypes.Product;
    currentProduct: any = {};
    quantityForm: QuantityForm = {} as QuantityForm;
    quantity = 1;

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }

    async init(config: Config, callback: any) {
        await super.init(config, callback);

        if (this.config.products) {

            this.products = this.config.products.filter((product: Product) => {
                return (product.type === ProductType.SINGLE_PAYMENT
                    || (this.includeNoPayment() && product.type === ProductType.NO_PAYMENT))
                    && !product.prices && !product.addon;
            });
        }
        if (this.products.every((product) => product.showQuantity)) {
            this.quantityForm = new QuantityForm();
            await this.quantityForm.init({}, {
                setQuantity: this.setQuantity.bind(this)
            });
            this.validators.push(new QuantityValidator());
        }
        return Promise.resolve();
    }

    setQuantity() {
        if (this.quantityForm.quantity !== 0) {
            this.quantity = this.quantityForm.quantity;
        } else {
            this.quantity = 1;
        }
        this.paymentData.amount = this.quantity * this.currentProduct.amount;
        if (this.config.products.length > 1) {
            this.paymentData.message = `One time fee: ${this.formatMoney(`${this.paymentData.amount}`, this.config.settings.currency)}`;
        }
        this.triggerEvent('amountChange');
    }

    async render() {
        this.view.setConfig(this.config);
        if (this.products.length > 1) {
            this.view.renderMultipleProducts(this.products, this.onSelectedProductChange.bind(this));
        }
        this.currentProduct = this.products[0] || {};
        this.paymentData.amount = this.currentProduct.amount || 0;
        this.paymentData.type = this.currentProduct.type;
        if (this.config.products.length > 1) {
            this.paymentData.message = `One time fee: ${this.formatMoney(`${this.paymentData.amount}`, this.config.settings.currency)}`;
        }
        if (this.products.every((product) => product.showQuantity)) {
            const quantityElementId = 'product';
            this.validationContext = { id: quantityElementId };
            await this.quantityForm.render(quantityElementId, this.currentProduct.name);
        }

        if (this.step) {
          this.hideForm();
        }

        this.view.preselectDfProductId();

        return Promise.resolve();
    }

    submit(order: Order) {

        let selectedProducts = this.getSelectedProducts() || [this.currentProduct];
        if (this.currentProduct.showQuantity) {
            this.currentProduct.quantity = this.quantity;
        }

        selectedProducts = this.setDiscount(selectedProducts);

        selectedProducts.forEach(product => {
            order.selectedProducts.push(product);
        });

        return Promise.resolve(order);
    }

    onSelectedProductChange(selectedProduct: any) {
        this.currentProduct = this.products.find((product) => product.name === selectedProduct.name);
        this.paymentData.amount = +selectedProduct.value * this.quantity;
        if (this.quantityForm.setProductName) {
            this.quantityForm.setProductName(this.currentProduct.name);
        }
        this.paymentData.message = `One time fee: ${this.formatMoney(`${this.paymentData.amount}`, this.config.settings.currency)}`;

        this.paymentData.type = this.currentProduct.type;

        if (this.currentProduct.type === ProductType.NO_PAYMENT) {
            this.isNoPayment = true;
        } else {
            this.isNoPayment = false;
        }

        this.triggerEvent('amountChange');
    }

    getSelectedProducts() {
        const viewData = this.view.getSelectedProduct();
        if (viewData) {
            const dfProducts = [viewData];
            const showQuantity = this.currentProduct.showQuantity;
            const quantity = this.quantity;
            return dfProducts.map((item: any) => {
                if (!item) {
                    return;
                }
                const selectedProd: any = {
                    dfProductId: item.getAttribute('df_product_id'),
                    name: item.getAttribute('product_name'),
                    amount: item.getAttribute('value'),
                    type: item.getAttribute('product_type')
                };
                if (showQuantity) {
                    selectedProd.quantity = quantity;
                }
                return selectedProd;
            });
        }
        return [this.currentProduct];
    }

    private setDiscount(selectedProducts: Array<any>) {
        if (this.config.settings && this.config.settings.discountId) {
            const coupon = this.config.settings.discountId;
            return selectedProducts.map((item: any) => {
                item.discountId = coupon.id;
                return item;
            });
        }
        return selectedProducts;
    }

    private includeNoPayment() {
        return this.config.products.some((product: Product) => {
            return product.type !== ProductType.SUBSCRIPTION;
        });
    }

    setAmountFromUrl(urlAmount: string) {
        const product = this.config.products[0];
        if (product.type === ProductType.SINGLE_PAYMENT) {
            product.amount = urlAmount;
            this.paymentData.amount = Number(urlAmount);
            this.triggerEvent('amountChange');
        }
    }

    showForm() {
        this.view.showForm();
        if (this.products.every((product) => product.showQuantity)) {
            this.quantityForm.showForm();
        }
    }

    hideForm() {
        this.view.hideForm();
        if (this.products.every((product) => product.showQuantity)) {
            this.quantityForm.hideForm();
        }
    }

}
